// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-title {
    font-size: 1.8rem;
    margin-bottom: 20px;
}

.request-form {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
}

.request-form input {
    padding: 10px;
    border-radius: 8px;
    border: 1px solid var(--border-color);
    background: var(--card-bg);
    color: var(--text-color);
}

.request-form button {
    padding: 10px 16px;
    border-radius: 8px;
    border: none;
    background: var(--primary-color);
    color: white;
    cursor: pointer;
}

.request-table-container {
    background: var(--card-bg);
    padding: 20px;
    border-radius: 12px;
    margin-bottom: 30px;
}

.request-table {
    width: 100%;
    border-collapse: collapse;
}

.request-table th,
.request-table td {
    padding: 12px;
    border-bottom: 1px solid var(--border-color);
}

.request-table th {
    text-align: left;
    font-weight: 600;
}

.request-chart-wrapper {
    margin-top: 30px;
}

.chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.chart-title {
    font-size: 1.4rem;
    color: var(--text-color);
}

.year-dropdown {
    padding: 8px 12px;
    border-radius: 8px;
    background: var(--card-bg);
    border: 1px solid var(--border-color);
    color: var(--text-color);
}


`, "",{"version":3,"sources":["webpack://./src/styles/Requests.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,qCAAqC;IACrC,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,gCAAgC;IAChC,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,aAAa;IACb,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;IAC1B,qCAAqC;IACrC,wBAAwB;AAC5B","sourcesContent":[".page-title {\r\n    font-size: 1.8rem;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.request-form {\r\n    display: flex;\r\n    gap: 10px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.request-form input {\r\n    padding: 10px;\r\n    border-radius: 8px;\r\n    border: 1px solid var(--border-color);\r\n    background: var(--card-bg);\r\n    color: var(--text-color);\r\n}\r\n\r\n.request-form button {\r\n    padding: 10px 16px;\r\n    border-radius: 8px;\r\n    border: none;\r\n    background: var(--primary-color);\r\n    color: white;\r\n    cursor: pointer;\r\n}\r\n\r\n.request-table-container {\r\n    background: var(--card-bg);\r\n    padding: 20px;\r\n    border-radius: 12px;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.request-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n}\r\n\r\n.request-table th,\r\n.request-table td {\r\n    padding: 12px;\r\n    border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.request-table th {\r\n    text-align: left;\r\n    font-weight: 600;\r\n}\r\n\r\n.request-chart-wrapper {\r\n    margin-top: 30px;\r\n}\r\n\r\n.chart-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.chart-title {\r\n    font-size: 1.4rem;\r\n    color: var(--text-color);\r\n}\r\n\r\n.year-dropdown {\r\n    padding: 8px 12px;\r\n    border-radius: 8px;\r\n    background: var(--card-bg);\r\n    border: 1px solid var(--border-color);\r\n    color: var(--text-color);\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
